import axios from 'axios';

export const submitUnsubscribeEmailRequest = (payload, formHeaders) =>
  axios.post('/communication-preferences/api/unsubscribe', payload, formHeaders);

export const submitConfirmationRequest = (payload, formHeaders) =>
  axios.post('/communication-preferences/api/confirm-unsubscribe-email', payload, formHeaders);
